import {IconsProps} from 'types';

export const AddToCartLoadingIcon = ({width = 32, height = 32, color = '#ffe6e5'}: IconsProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="18" cy="18" r="17" fill="#F22643" stroke={color} strokeWidth="2" />

      <circle cx="18" cy="18" r="16.5" fill={color} stroke="#F22643" strokeWidth="1" />

      <g fill="#F22643">
        <circle cx="12" cy="18" r="2" />
        <circle cx="18" cy="18" r="2" />
        <circle cx="24" cy="18" r="2" />
      </g>
    </svg>
  );
};

AddToCartLoadingIcon.displayName = 'MakroUI.AddToCartLoadingIcon';
